import Vue from 'vue';
import Vuex from 'vuex';
//root级mutations
import mutations from './mutations'
//root级actions
import actions from './actions'
//root级getters
import getters from './getters'

//单个模块状态
import math from './modules/math/index'
import english from './modules/english/index'
import chinese from './modules/chinese/index'
import qualityStation from './modules/qualityStation/index'
import classmange from './modules/class/index'

//个性化学习h5首页，存储页面展示状态
import personaLearning from './modules/personaLearning/index'

//2022寒假活动，存储tab状态,按学生/作业查看
import winter2022 from './modules/active/2022winter/index'

Vue.use(Vuex);

const state = {//公共变量
    unitList: [],
    msg: {}, //储存发作业信息
    bgType: true, //背景颜色  默认是教师的背景颜色
    error_details: [], //错题本作业提交的数据 到结果页用
    loading: true,//加载 loading
    sharData: null,//期末作业分享预览数据
    activeTitle: '', //期末作业title
    mapLoading: false, //暑假作业 loading
    winterlevel: 0,
    wrongArr: [], //订正错题数据
    errorTabIndex: 0,//错题集列表
    urlOrigin: '0',//埋点
    tabNum: 1,//作业详情导航位置  1:完成情况 2:作业报告
}

export default new Vuex.Store({
    state,
    mutations,
    actions,
    getters,
    modules: {
        math,
        english,
        chinese,
        qualityStation,
        personaLearning,
        winter2022,
        classmange
    }
})
